import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography
} from '@mui/material';
import React, { ReactNode } from 'react';



export type FormBaseLayoutProps = {
  title?: string;
  subtitle?: string;
  successButtonText?: string;
  cancelButtonText?: string;
  ignoreCancel?: boolean;
  handleSubmit: () => void;
  handleCancel: () => void;
  children: ReactNode | ReactNode[];
  isLoading?: boolean;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: FormBaseLayoutProps) => {

  return (
    <Box
      height='100%'
      component='form'
      onKeyDown={(val) => {
        if (val.code === 'Enter' && val.metaKey) {
          val.preventDefault();
          props.handleSubmit();
        }
        if (val.code === 'Enter') {
          val.preventDefault();
          return val;
          // return val.currentTarget.value;
        }

      }}

      onSubmit={(e) => {

        e.preventDefault();
        props.handleSubmit();
      }}
    >
      <Stack
        direction='column'
        justifyContent='space-between'
        height='100%'

      >
        <Stack
          direction='column'
          gap='0.25rem'
        >
          {props.title && (
            <Typography
              variant='modalTitle'
              textAlign='center'
            >
              {props.title}
            </Typography>
          )}
          {props.subtitle && (
            <Typography
              variant='modalSubTitle'
              textAlign='center'
            >
              {props.subtitle}
            </Typography>
          )}
          {props.children}

        </Stack>

        {/* BUTTONS */}
        {
          props.isLoading
            ? (
              <Box
                display='flex'
                alignContent='center'
                justifyContent='center'
              >

                <CircularProgress
                  variant='indeterminate'
                />
              </Box>
            )
            : (
              <Stack
                direction='row'
                paddingY='1.5rem'
                gap='0.5rem'
              >
                {!props.ignoreCancel && (

                  <Button
                    fullWidth
                    variant='outlined'
                    color='secondary'
                    onClick={props.handleCancel}
                  >
                    {
                      props.cancelButtonText
                        ? props.cancelButtonText
                        : 'Cancel'
                    }
                  </Button>
                )}
                <Button
                  fullWidth
                  type='submit'
                  variant='contained'
                >
                  {
                    props.successButtonText
                      ? props.successButtonText
                      : 'Submit'
                  }
                </Button>
              </Stack>
            )
        }
      </Stack>
    </Box>

  );
};
